import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 31 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3.156 0A2.25 2.25 0 0 0 .912 2.25v15a2.25 2.25 0 0 0 2.244 2.25h.749c0 2.484 2.01 4.5 4.489 4.5a4.496 4.496 0 0 0 4.488-4.5h5.986c0 2.484 2.01 4.5 4.489 4.5a4.496 4.496 0 0 0 4.488-4.5h1.497c.827 0 1.496-.67 1.496-1.5s-.669-1.5-1.496-1.5v-5.377c0-.796-.314-1.56-.875-2.123l-3.614-3.623a3 3 0 0 0-2.118-.877h-2.371V2.25A2.25 2.25 0 0 0 18.119 0zm17.208 7.5h2.37l3.615 3.623V12h-5.985zm-14.215 12c0-.597.237-1.169.657-1.591a2.242 2.242 0 0 1 3.832 1.591c0 .597-.236 1.169-.657 1.591A2.242 2.242 0 0 1 6.149 19.5m17.208-2.25c.595 0 1.166.237 1.587.659a2.253 2.253 0 0 1-1.587 3.841 2.24 2.24 0 0 1-1.588-.659 2.253 2.253 0 0 1 0-3.182 2.24 2.24 0 0 1 1.588-.659" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }